import { setCookie } from '../Helpers/getConfig'
import { isCatex } from '../Helpers/index'

export const parseDataForMigration = (data) => {
  const MAX_NUMBER_OF_ITEMS = 100
  return [
    data.slice(0, MAX_NUMBER_OF_ITEMS).reduce((acc, currentItem) => {
      acc[currentItem.sku] = currentItem.quantity
      return acc
    }, {}),
  ]
}

export const saveCookieForMigration = (data) => {
  if (isCatex()) {
    return
  }
  const cookieName = 'legacy_cart'
  const cookieMaxAge = 99
  const parsedData = parseDataForMigration(data)
  const uriEncodedData = encodeURIComponent(JSON.stringify(parsedData).replace(' ', ''))
  setCookie(cookieName, uriEncodedData, cookieMaxAge, true)
}
